import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import {Dropdown} from '@homeaway/react-dropdown';

export class InternalTools extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        customToggle: PropTypes.element,
        dropdownRight: PropTypes.bool,
        id: PropTypes.string,
        label: PropTypes.string,
    };

    static defaultProps = {
        dropdownRight: true,
        id: 'site-header__internal-tools',
        label: 'Internal Tools',
    };

    render() {
        if (!this.props.children) {
            return null;
        }

        let {children, className, customToggle, id, label, ...dropdownProps} = this.props;

        className = classNames('site-header-nav__dropdown', className);

        /* istanbul ignore else */
        if (!customToggle) {
            customToggle = (
                <span
                    aria-expanded="false"
                    aria-haspopup="true"
                    className="site-header-nav__toggle Dropdown__toggle"
                    id={id}
                    role="button"
                >
                    {label} <span aria-hidden="true" className="caret" />
                </span>
            );
        }

        return (
            <Dropdown className={className} customToggle={customToggle} id={id} label={label} {...dropdownProps}>
                {children}
            </Dropdown>
        );
    }
}
